import Link from '@grebban/react-core-components/Link';
import React from 'react';
import styled from '@grebban/style-system-react';
import { media } from '@fogia/core-web/utils/mediaqueries';

const StyledLink = styled(Link)`
    text-decoration: underline;

    ${media.hover} {
        &:hover {
            color: var(--button-tertiery-text-hover);
        }
    }
`;

interface LinkProps {
    href?: string;
    target?: '_self' | '_blank';
    children: React.ReactNode;
}

const PortableTextLink: React.FC<LinkProps> = ({ href, target, children }) => {
    if (!href) {
        return children;
    }

    return (
        <StyledLink to={href} target={target} tabIndex={0}>
            {children}
        </StyledLink>
    );
};

export default PortableTextLink;
